import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import { getAccessToken } from "sr/helpers/functions/setAccessTokenMe";

export const verifyOTP = async (postData:any, options?: { authRequired?: boolean }) => {
    try {
        const token = getAccessToken();
        const headers =
            options?.authRequired && token ? { Authorization: `Bearer ${token}` } : undefined;

        return await post<ApiResponse<[]>>('/auth/verifyotp', postData, undefined, headers).then((res)=> {
            if(res.success === true) {
                SuccessMessage('API.SUCCESS.OTP.VERIFY')
                return res
            }
            else {
                return null
            }
        })
    }
    catch(e:any) {
     HandleApiError(e)
    }
}